
export default {
    name: 'SellerConfirm',
    props: {
        content: {
            type: Object,
            default: () => ({})
        },
        mentionedUser: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            btnLoading: false
        }
    },
    methods: {
        async confirm () {
            try {
                const params = {
                    modifyOrderCardType: this.content.type,
                    couponsCode: null,
                    idToken: this.content.idToken,
                    modifyOrderNo: this.content.modifyOrderNo,
                    noUseCoupon: null,
                    orderId: this.content.orderId
                }
                this.btnLoading = true
                const res = await this.$api.changePriceConfirm(params)
                this.btnLoading = false
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.$message.success('已确认改价')
            } catch (err) {
                this.btnLoading = false
            }
        }
    }
}
